import { css } from '@emotion/css';
import { cssVarV2 } from '@streamlain/theme/v2';

import { slimDataViewScrollbarStyle } from '../../shared/slim-scrollbar-style.js';
import { DEFAULT_COLUMN_TITLE_HEIGHT, LEFT_TOOL_BAR_WIDTH } from '../consts.js';

export const tableView = css({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  height: '100%',
  minHeight: 0,
  maxHeight: '100%',
  overflow: 'hidden',
});

export const tableContainer = css({
  position: 'relative',
  flex: '1 1 auto',
  minHeight: 0,
  maxHeight: '100%',
  overflowX: 'hidden',
  overflowY: 'auto',
  overscrollBehaviorY: 'none',
  overscrollBehaviorX: 'contain',
  ...slimDataViewScrollbarStyle,
});

export const horizontalScrollbar = css({
  position: 'relative',
  flex: '0 0 16px',
  height: '16px',
  minHeight: '16px',
  cursor: 'grab',
  touchAction: 'none',
  userSelect: 'none',
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'var(--streamlain-hover-color)',
  },
  '&:active': {
    cursor: 'grabbing',
  },
});

export const horizontalScrollbarThumb = css({
  position: 'absolute',
  top: '5px',
  left: 0,
  height: '6px',
  minWidth: '32px',
  borderRadius: '3px',
  backgroundColor: 'var(--streamlain-black-30)',
  pointerEvents: 'none',
});

export const tableBlockTable = css({
  position: 'relative',
  width: '100%',
  paddingBottom: '4px',
  zIndex: 1,
  overflowX: 'hidden',
  overflowY: 'hidden',
  overscrollBehaviorX: 'contain',
});

export const tableContainer2 = css({
  position: 'relative',
  width: 'fit-content',
  minWidth: '100%',
  '& virtual-table-group-header virtual-table-header': {
    visibility: 'hidden',
  },
});

export const stickyColumnHeader = css({
  position: 'sticky',
  top: 0,
  left: 0,
  zIndex: 30,
  height: `${DEFAULT_COLUMN_TITLE_HEIGHT}px`,
  marginBottom: `-${DEFAULT_COLUMN_TITLE_HEIGHT}px`,
  overflow: 'hidden',
  pointerEvents: 'none',
  backgroundColor: 'var(--streamlain-background-primary-color)',
  contain: 'paint',
});

export const stickyColumnHeaderInner = css({
  position: 'relative',
  width: 'max-content',
  minWidth: '100%',
  height: '100%',
  overflow: 'hidden',
  backgroundColor: 'var(--streamlain-background-primary-color)',
  pointerEvents: 'auto',
  isolation: 'isolate',
  willChange: 'transform',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: '-1px 0',
    zIndex: -1,
    backgroundColor: 'var(--streamlain-background-primary-color)',
    pointerEvents: 'none',
  },
});

export const addGroup = css({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  padding: '6px 12px 6px 8px',
  color: cssVarV2.text.secondary,
  fontSize: '12px',
  lineHeight: '20px',
  position: 'sticky',
  left: `${LEFT_TOOL_BAR_WIDTH}px`,
});
